import styled, { css } from 'styled-components';
import {} from './index.js';
import { getTypographyStyles, SYS_SIZE_FIXED_1000, SYS_SIZE_FIXED_1200, SYS_SIZE_FIXED_1600, SYS_SIZE_FIXED_250, SYS_SIZE_FIXED_300, SYS_SIZE_FIXED_400, SYS_SIZE_FIXED_600, SYS_SIZE_FIXED_700, CMP_TYPOGRAPHY_UI_TEXT_LIST_MD_LABEL, CMP_TYPOGRAPHY_UI_TEXT_LIST_SM_LABEL, CMP_TYPOGRAPHY_UI_TEXT_LIST_XS_LABEL, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-common';
import { Icon } from '../icon/index.js';
import { getMargins } from '@oneaudi/unified-web-common';
export const ListItem = styled.li ``;
export const StyledIcon = styled(Icon) `
  position: absolute;
  left: 0;
`;
export const StyledHiddenBullet = styled.div ``;
export const StyledList = styled.ul `
  position: relative;
  list-style-type: none;
  counter-reset: section;

  ${(props) => props.variant === 'icon'
    ? css `
          padding: 0 0 0
            calc(
              ${props.size === 'md' ? '24px' : '16px'} +
                ${props.size === 'md'
        ? SYS_SPACE_FIXED_200
        : props.size === 'sm'
            ? SYS_SPACE_FIXED_150
            : SYS_SPACE_FIXED_100}
            );
        `
    : css `
          padding: 0 0 0
            calc(
              ${props.size === 'md'
        ? SYS_SIZE_FIXED_400
        : props.size === 'sm'
            ? SYS_SIZE_FIXED_300
            : SYS_SIZE_FIXED_250} +
                ${props.size === 'md'
        ? SYS_SPACE_FIXED_200
        : props.size === 'sm'
            ? SYS_SPACE_FIXED_150
            : SYS_SPACE_FIXED_100}
            );
        `}

  ${(props) => {
    switch (props.size) {
        case 'xs':
            return getTypographyStyles(CMP_TYPOGRAPHY_UI_TEXT_LIST_XS_LABEL);
        case 'sm':
            return getTypographyStyles(CMP_TYPOGRAPHY_UI_TEXT_LIST_SM_LABEL);
        default:
            return getTypographyStyles(CMP_TYPOGRAPHY_UI_TEXT_LIST_MD_LABEL);
    }
}}

  color: ${(props) => props.theme.sem.color.ui.foreground.text.default};
  margin: ${(props) => getMargins(props.margin) || 0};

  ${(props) => css `
    ${ListItem} {
      &::before,
      ${StyledHiddenBullet} {
        text-align: end;
        display: inline-block;
        width: ${props.size === 'md'
    ? SYS_SIZE_FIXED_400
    : props.size == 'sm'
        ? SYS_SIZE_FIXED_300
        : SYS_SIZE_FIXED_250};
      }
    }
  `}

  ${(props) => props.variant === 'icon' &&
    css `
      ${ListItem} {
        &::before {
          display: none;
        }
      }
    `}

  // Second Level
  ol,
  ul {
    margin: ${(props) => props.size === 'md' ? SYS_SPACE_FIXED_200 : SYS_SPACE_FIXED_150}
      0;
    transform: translateX(
      calc(
        (
            ${(props) => props.size === 'md'
    ? SYS_SIZE_FIXED_400
    : props.size === 'sm'
        ? SYS_SIZE_FIXED_300
        : SYS_SIZE_FIXED_250} +
              ${(props) => props.size === 'md'
    ? SYS_SPACE_FIXED_200
    : props.size === 'sm'
        ? SYS_SPACE_FIXED_150
        : SYS_SPACE_FIXED_100}
          ) * -1
      )
    );

    ${StyledIcon} {
      left: ${(props) => props.size === 'md'
    ? SYS_SIZE_FIXED_1000
    : props.size === 'sm'
        ? SYS_SIZE_FIXED_700
        : SYS_SIZE_FIXED_600};
      transform: translateX(
        ${(props) => (props.size === 'md' ? '-24px' : '-16px')}
      );
    }

    counter-reset: subsection;

    padding: 0 0 0
      calc(
        ${(props) => props.size === 'md'
    ? SYS_SIZE_FIXED_1000
    : props.size === 'sm'
        ? SYS_SIZE_FIXED_700
        : SYS_SIZE_FIXED_600} +
          ${(props) => props.size === 'md'
    ? SYS_SPACE_FIXED_200
    : props.size === 'sm'
        ? SYS_SPACE_FIXED_150
        : SYS_SPACE_FIXED_100}
      );

    ${ListItem} {
      counter-increment: subsection;

      &::before,
      ${StyledHiddenBullet} {
        width: ${(props) => props.size === 'md'
    ? SYS_SIZE_FIXED_1000
    : props.size === 'sm'
        ? SYS_SIZE_FIXED_700
        : SYS_SIZE_FIXED_600};
      }

      // Third Level
      ol,
      ul {
        padding: 0 0 0
          calc(
            ${(props) => props.size === 'md'
    ? SYS_SIZE_FIXED_1600
    : props.size === 'sm'
        ? SYS_SIZE_FIXED_1200
        : SYS_SIZE_FIXED_1000} +
              ${(props) => props.size === 'md'
    ? SYS_SPACE_FIXED_200
    : props.size === 'sm'
        ? SYS_SPACE_FIXED_150
        : SYS_SPACE_FIXED_100}
          );

        transform: translateX(
          calc(
            (
                ${(props) => props.size === 'md'
    ? SYS_SIZE_FIXED_1000
    : props.size === 'sm'
        ? SYS_SIZE_FIXED_700
        : SYS_SIZE_FIXED_600} +
                  ${(props) => props.size === 'md'
    ? SYS_SPACE_FIXED_200
    : props.size === 'sm'
        ? SYS_SPACE_FIXED_150
        : SYS_SPACE_FIXED_100}
              ) * -1
          )
        );
        counter-reset: subsubsection;

        ${StyledIcon} {
          left: ${(props) => props.size === 'md'
    ? SYS_SIZE_FIXED_1600
    : props.size === 'sm'
        ? SYS_SIZE_FIXED_1200
        : SYS_SIZE_FIXED_1000};

          transform: translateX(
            ${(props) => (props.size === 'md' ? '-24px' : '-16px')}
          );
        }

        li {
          counter-increment: subsubsection;
          &::before,
          ${StyledHiddenBullet} {
            width: ${(props) => props.size === 'md'
    ? SYS_SIZE_FIXED_1600
    : props.size === 'sm'
        ? SYS_SIZE_FIXED_1200
        : SYS_SIZE_FIXED_1000};
          }

          ${(props) => props.variant === 'lower-alpha' &&
    css `
              &::before {
                content: counter(section, lower-alpha) '.'
                  counter(subsection, lower-alpha) '.'
                  counter(subsubsection, lower-alpha) '.';
              }
            `}

          ${(props) => props.variant === 'decimal' &&
    css `
              &::before {
                content: counter(section, decimal) '.'
                  counter(subsection, decimal) '.'
                  counter(subsubsection, decimal) '.';
              }
            `}
        }
      }

      ${(props) => props.variant === 'lower-alpha' &&
    css `
          &::before {
            content: counter(section, lower-alpha) '.'
              counter(subsection, lower-alpha) '.';
          }
        `}

      ${(props) => props.variant === 'decimal' &&
    css `
          &::before {
            content: counter(section, decimal) '.' counter(subsection, decimal)
              '.';
          }
        `}
    }
  }

  ${ListItem} {
    counter-increment: section;

    ${(props) => props.variant === 'bullet' &&
    css `
        ${StyledHiddenBullet} {
          position: absolute;
          left: 0;
        }
      `}

    ${(props) => props.variant === 'lower-alpha' &&
    css `
        &::before {
          position: absolute;
          left: 0;
          content: counter(section, lower-alpha) '.';
        }
      `}

      ${(props) => props.variant === 'decimal' &&
    css `
        &::before {
          position: absolute;
          left: 0;
          content: counter(section, decimal) '.';
        }
      `}

    &:not(:last-child) {
      ${(props) => {
    if (props.size === 'md') {
        return css `
            margin-bottom: ${SYS_SPACE_FIXED_200};
          `;
    }
    return css `
          margin-bottom: ${SYS_SPACE_FIXED_150};
        `;
}}
    }
  }
`;
//# sourceMappingURL=index.styles.js.map